module.exports = __webpack_public_path__ + "img/use-your-own-image.46396891.png";